import { MdFavoriteBorder } from "react-icons/md";
import { MdOutlineBookmarkBorder } from "react-icons/md";
import { IoBagOutline } from "react-icons/io5";
import { PiNumberFiveFill } from "react-icons/pi";
import { GoPerson } from "react-icons/go";
import { LiaAddressCardSolid } from "react-icons/lia";
import { MdPayment } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import { FaRegEdit } from "react-icons/fa";

const Payment = () => {
  return (
    <div className="">
      <div className="p-2 md:p-5 bg-gray-200">
          <h1 className=" font-bold text-lg flex justify-center">Payment</h1>
      </div>
      <div className=" p-5">
      <div className=" flex gap-5 w-full">
        <div className="w-[300px] h-[220px] md:w-[430px] md:h-[280px] border border-gray-300 mt-5  ">
          <div className="py-2 px-2 flex justify-between md:py-5  md:px-3  border-b-2 ">
            <h4 className="text-sm font-bold">Visa Card</h4>
            <img src="/assets/card-visa.png" width={30} height={30} />
          </div>
          <div className="mt-1 px-1 md:mt-3 md:px-3">
            <label className="text-sm block md:text-gray-600 uppercase ">
              Card Number
            </label>
            <span className="text-xs md:text-black font-bold md:text-sm">
              xxxx xxxx xxxx 5050
            </span>
          </div>
          <div className="py-2 px-1 mt-1 flex justify-between md:px-3 border-b-2 md:py-5  md:mt-3">
            <div>
              <label className="text-sm md:block  text-gray-600 uppercase">
                NAME OF CARD
              </label>
              <span className="text-xs md:text-black font-bold md:text-sm">
                Nancy Bayers
              </span>
            </div>
            <div className="  ">
              <label className=" text-sm md:block text-gray-600 uppercase">
                VALIDITY
              </label>
              <span className="text-sm md:text-black font-bold">xx / xx</span>
            </div>
          </div>
          <div className="px-1 mt-2 md:mt-3 flex justify-between md:px-3 font-semibold ">
            <button className="text-xs text-primary md:text-primary hover:text-red-800  uppercase">
              Edit
            </button>
            <button className=" text-xs text-primary md:text-primary hover:text-red-800  uppercase">
              Remove
            </button>
          </div>
        </div>
        <div className="w-[300px] h-[220px] md:w-[430px] md:h-[280px] border border-gray-300 mt-5  ">
          <div className="py-2 px-2 flex justify-between md:py-5  md:px-3  border-b-2 ">
            <h4 className="text-sm font-bold">Visa Card</h4>
            <img src="/assets/card-master.png" width={30} height={30} />
          </div>
          <div className="mt-1 px-1 md:mt-3 md:px-3">
            <label className="text-sm block md:text-gray-600 uppercase ">
              Card Number
            </label>
            <span className="text-xs md:text-black font-bold md:text-sm">
              xxxx xxxx xxxx 5050
            </span>
          </div>
          <div className="py-2 px-1 mt-1 flex justify-between md:px-3 border-b-2 md:py-5  md:mt-3">
            <div>
              <label className="text-sm md:block  text-gray-600 uppercase">
                NAME OF CARD
              </label>
              <span className="text-xs md:text-black font-bold md:text-sm">
                Nancy Bayers
              </span>
            </div>
            <div className="  ">
              <label className=" text-sm md:block text-gray-600 uppercase">
                VALIDITY
              </label>
              <span className="text-sm md:text-black font-bold">xx / xx</span>
            </div>
          </div>
          <div className="px-1 mt-2 md:mt-3 flex justify-between md:px-3 font-semibold ">
            <button className="text-xs text-primary md:text-primary hover:text-red-800  uppercase">
              Edit
            </button>
            <button className=" text-xs text-primary md:text-primary hover:text-red-800  uppercase">
              Remove
            </button>
          </div>
        </div>
      </div>
      <div className=" w-[350px] h-[200px] border border-gray-300 md:w-full md:h-[240px] mt-5 ">
        <div className="px-3 py-5 border-b-2 ">
          <h4 className="text-xs md:font-bold md:text-sm">Add </h4>
        </div>
        <div className=" mt-3 px-3 py-3 w-[200px] md:mt-5 flex justify-between md:px-3 md:py-5 md:w-[600px] gap-5 ">
          <input
            className="w-[140px] px-1 py-1 text-xs md:outline-none border border-gray-300  md:w-full md:px-3 md:py-2"
            type="text"
            placeholder="card Number"
          />
          <input
            className="w-[140px] px-1 py-1 text-xs md:outline-none border border-gray-300  md:w-full md:px-3 md:py-2"
            type="text"
            placeholder="Your Name"
          />
        </div>
        <div className="  gap-3 flex px-3 py-2 justify-between md:px-3 md:gap-5">
          <div className="w-[200px] gap-3  md:w-[300px] flex md:gap-5">
            <input
              type="text"
              placeholder="Expiry Date"
              className=" w-full px-1 py-1 text-xs md:outline-none border border-gray-300 md:w-full md:px-3 md:py-2 "
            />
            <input
              type="text"
              placeholder="CVC"
              className=" w-full px-1 py-1 text-xs outline-none border border-gray-300 md:w-full md:px-3 md:py-2"
            />
          </div>
          <div className=" w-[200px] md:w-[300px] flex justify-end">
            <button className="text-xs w-full px-1 py-1  md:text-sm bg-primary text-white md:px-3 md:py-2 md:w-full font-medium hover:bg-red-800">
              Register the card
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};
export default Payment;
